import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import plusCircle from "../../assets/icons/plusCircle.svg";
import "../../assets/styles/local/Project.css";
import axios from "axios";
import { OverlayTrigger } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchProject,
  FetchProjectBB,
  UpdateProjectCover,
  DeleteProject,
} from "../../redux/actions/action";
import { API_URL } from "../../redux/constants/type";
import ArrowIcon from "../../assets/icons/arrowdown.svg";
import deleteIcon from "../../assets/icons/Bin.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const ProjectBBList = ({ query, setShowLoader }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const fetchProjectBB = useSelector((state) => state.user.fetchProjectBB);
  const deleteProjectRes = useSelector((state) => state.user.deleteProjectRes);

  const companyId = window.localStorage.getItem("companyid");
  const roleid = window.localStorage.getItem("roleid");

  const fetchProject = useSelector((state) => state.user.fetchProject);
  const updateProjectCover = useSelector(
    (state) => state.user.updateProjectCover,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Project-List").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [projectid2, setProjectid2] = useState("");
  const [listData, setListData] = useState([]);

  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const main = getAppSideNavOptions.some(
        (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
      );
      setIsBuildingBlock(main);
      if (main === true) {
        dispatch(
          FetchProjectBB(
            companyId,
            "Asc-ProjectName",
            process.env.REACT_APP_IS_PREMIUM,
          ),
        );
      } else {
        dispatch(FetchProject(companyId));
      }
    }
  }, [getAppSideNavOptions, deleteProjectRes]);

  const processProjectData = (data) =>
    data?.data &&
    data.status === true &&
    data.data[0] &&
    data.data[0].projectstatus &&
    Array.isArray(data.data[0].projectstatus)
      ? data.data[0].projectstatus
      : [];

  useEffect(() => {
    if (isBuildingBlock) {
      setListData(processProjectData(fetchProjectBB));
      setShowLoader(false);
    } else {
      setListData(processProjectData(fetchProject));
      setShowLoader(false);
    }
  }, [
    fetchProjectBB,
    fetchProject,
    isBuildingBlock,
    fetchProjectBB?.data,
    fetchProject?.data,
  ]);

  const hidden_Input_File1 = useRef([]);
  const handleIMGClick1 = (index) => {
    hidden_Input_File1.current[index].click();
  };

  const [add_image, setAdd_image] = useState("");

  const handleFileUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    const formData = new FormData();
    formData.append("file", fileUploaded);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      setTimeout(() => {
        dispatch(UpdateProjectCover(projectid2, response.data[0]));
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };

  const onDrag_handleFileUpload = async (e, item) => {
    const formData = new FormData();
    formData.append("file", e);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      setAdd_image(response.data[0]);

      setTimeout(() => {
        dispatch(UpdateProjectCover(item.projectid, response.data[0]));
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //     const fetchData = async () => {
  //         let fetchAction;
  //         if (isBuildingBlock) {
  //             setListData([])
  //             fetchAction = FetchProjectBB(companyId, process.env.REACT_APP_IS_PREMIUM);
  //         } else {
  //             fetchAction = FetchProject(companyId);
  //         }

  //         try {
  //             await dispatch(fetchAction);
  //             setTimeout(() => {
  //                 setShowLoader(false);
  //             }, 1000);
  //         } catch (error) {
  //             console.error(error);
  //         }
  //     };

  //     fetchData();
  // }, [isBuildingBlock]);

  useEffect(() => {
    if (updateProjectCover?.status === true) {
      if (isBuildingBlock) {
        dispatch(
          FetchProjectBB(
            companyId,
            "Asc-ProjectName",
            process.env.REACT_APP_IS_PREMIUM,
          ),
        );
      } else {
        dispatch(FetchProject(companyId));
      }
    }
  }, [updateProjectCover]);

  //functionality of radio button show color
  const getPriorityColor = (priorityid) => {
    switch (priorityid) {
      case "08da8a3e-d43a-40b9-845d-ba8c2e749692":
        return "green"; // High priority
      case "08da8a3e-d43a-40b9-845d-ba8c2e749693":
        return "yellow"; // Low priority
      case "08da8a3e-d43a-40b9-845d-ba8c2e749694":
        return "orange"; // Medium priority
      default:
        return ""; // Default priority
    }
  };

  return (
    <div className="pb-5">
      {listData?.map((items, index) => {
        return (
          <div key={index}>
            <div className="salesPipeline text-uppercase">
              <div className="innerSalePipeline">{items.statusname}</div>
            </div>
            <div className="row gap-4 smallTitle">
              {items?.projectdetails
                ?.filter(
                  (items) =>
                    items.projectname
                      ?.toLowerCase()
                      .includes(query?.toLowerCase()) ||
                    items.clientname
                      ?.toLowerCase()
                      .includes(query?.toLowerCase()) ||
                    items.contactname
                      ?.toLowerCase()
                      .includes(query?.toLowerCase()) ||
                    items.contactForDelivery
                      ?.toLowerCase()
                      .includes(query?.toLowerCase()) ||
                    items.contactEmail
                      ?.toLowerCase()
                      .includes(query?.toLowerCase()) ||
                    items.deliveryAddress
                      ?.toLowerCase()
                      .includes(query?.toLowerCase()) ||
                    items.contactPhonenumber
                      ?.toLowerCase()
                      .includes(query?.toLowerCase()) ||
                    items.projectmanagername
                      ?.toLowerCase()
                      .includes(query?.toLowerCase()) ||
                    items.notes?.toLowerCase().includes(query?.toLowerCase()) ||
                    items.completiondate
                      ?.toLowerCase()
                      .includes(query?.toLowerCase()),
                )
                ?.sort((a, b) => a.projectname.localeCompare(b.projectname))
                ?.map((item, index) => {
                  return (
                    <>
                      {item.projectcover ? (
                        <div
                          className="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 proDiv"
                          key={index}
                        >
                          <img
                            className="proimg pointer hide-on-mobile"
                            src={item.projectcover}
                            alt=""
                            onClick={() => {
                              window.localStorage.setItem(
                                "projectid",
                                item.projectid,
                              );
                              history.push(`/project/${item.projectid}`);
                            }}
                          />

                          <div
                            className="assign_probablity_line"
                            style={{
                              width: "clamp(241px, 17.813vw, 17.813vw)",
                              height: "8px",
                              borderRadius: "0px 0px 5px 5px",
                              position: "relative",
                              bottom: "6px",
                              backgroundColor: getPriorityColor(
                                item.priorityid,
                              ),
                            }}
                          ></div>

                          <OverlayTrigger
                            key={index}
                            placement="top"
                            id="asctooltip"
                            // show={show}
                            // target={target}
                            delay={{ show: 400, hide: 500 }}
                            overlay={
                              <div
                                id={`tooltip-${item.projectid}`}
                                style={{ paddingLeft: "15rem" }}
                              >
                                <p className="ascOverlay px-1">
                                  {item.projectname.length > 30 &&
                                    item.projectname}
                                </p>
                              </div>
                            }
                          >
                            <p
                              className="clntname pt-2 pointer"
                              onClick={() => {
                                window.localStorage.setItem(
                                  "projectid",
                                  item.projectid,
                                );
                                history.push(`/project/${item.projectid}`);
                              }}
                            >
                              {item.projectname.length > 30
                                ? item.projectname.slice(0, 30) + "..."
                                : item.projectname}
                              <img
                                alt=""
                                src={ArrowIcon}
                                className="ArrowIcon-show-in-mobile"
                              />
                            </p>
                          </OverlayTrigger>

                          <p
                            className="clntname pointer hide-on-mobile d-flex"
                            onClick={() => {
                              window.localStorage.setItem(
                                "projectid",
                                item.projectid,
                              );
                              history.push(`/project/${item.projectid}`);
                            }}
                          >
                            {item.clientname
                              ? item.clientname
                              : item.contactname
                                ? item.contactname
                                : ""}

                            {roleid ===
                              "08da3f0d-0371-4dd3-8c86-e51222d56188" && (
                              <span className="ms-auto">
                                <img
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(
                                      DeleteProject({
                                        projectid: item.projectid,
                                      }),
                                    );
                                  }}
                                  src={deleteIcon}
                                  className="card-plus-img ms-auto me-"
                                  style={{ width: "14px" }}
                                  alt=""
                                />
                              </span>
                            )}
                          </p>
                        </div>
                      ) : add_image && projectid2 === item.projectid ? (
                        <div className="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 proDiv">
                          <div
                            key={index}
                            className="add_picture_Div"
                            // onClick={() => {
                            //   window.localStorage.setItem("projectid", item.projectid);
                            //   history.push("/updateProject");
                            // }}
                          >
                            <img
                              src={add_image}
                              className="proimg pointer"
                              alt=""
                            />

                            <div>
                              <OverlayTrigger
                                key={index}
                                placement="top"
                                id="asctooltip"
                                // show={show}
                                // target={target}
                                delay={{ show: 400, hide: 500 }}
                                overlay={
                                  <div
                                    id={`tooltip-${item.projectid}`}
                                    style={{ paddingLeft: "15rem" }}
                                  >
                                    <p
                                      className="ascOverlay px-1 pointer"
                                      onClick={() => {
                                        window.localStorage.setItem(
                                          "projectid",
                                          item.projectid,
                                        );
                                        history.push(
                                          `/project/${item.projectid}`,
                                        );
                                      }}
                                    >
                                      {item.projectname.length > 30 &&
                                        item.projectname}
                                    </p>
                                  </div>
                                }
                              >
                                <div
                                  className="assign_probablity_line"
                                  style={{
                                    width: "clamp(241px, 17.813vw, 17.813vw)",
                                    height: "8px",
                                    borderRadius: "0px 0px 5px 5px",
                                    position: "relative",
                                    bottom: "6px",
                                    backgroundColor: getPriorityColor(
                                      item.priorityid,
                                    ),
                                  }}
                                ></div>
                                <p
                                  className="clntname pt-2 pointer"
                                  onClick={() => {
                                    window.localStorage.setItem(
                                      "projectid",
                                      item.projectid,
                                    );
                                    history.push(`/project/${item.projectid}`);
                                  }}
                                >
                                  {item.projectname.length > 30
                                    ? item.projectname.slice(0, 30) + "..."
                                    : item.projectname}
                                </p>
                              </OverlayTrigger>

                              <p
                                className="clntname pointer"
                                onClick={() => {
                                  window.localStorage.setItem(
                                    "projectid",
                                    item.projectid,
                                  );
                                  history.push(`/project/${item.projectid}`);
                                }}
                              >
                                {item.clientname
                                  ? item.clientname
                                  : item.contactname
                                    ? item.contactname
                                    : ""}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 proDiv">
                          <div
                            className="add_picture_Div hide-on-mobile"
                            // on drag upload img start
                            onDragOver={(e) => {
                              e.preventDefault();
                            }}
                            onDrop={(e) => {
                              e.preventDefault();
                              const droppedFile = Array.from(
                                e.dataTransfer.files,
                              );
                              // handleFileUpload(e);
                              if (droppedFile) {
                                onDrag_handleFileUpload(droppedFile[0], item);
                              }
                            }}
                            // on drag upload img end
                          >
                            <img
                              src={plusCircle}
                              className="pro_plusImg pt-4 mt-2 pt-sm-4 pt-md-4 pt-xl-4 pt-xxl-4 mt-sm- mt-md- mt-xl-2 mt-xxl-4"
                              alt=""
                              onClick={() => {
                                setProjectid2(item.projectid);
                                handleIMGClick1(index);
                              }}
                            />

                            <input
                              multiple
                              type="file"
                              accept="image/*"
                              ref={(el) =>
                                (hidden_Input_File1.current[index] = el)
                              }
                              style={{ display: "none" }}
                              onChange={(e) => {
                                // const fileUploaded = e.target.files[ 0 ];

                                // const imageLoaded = URL.createObjectURL(fileUploaded);
                                // setAdd_image(imageLoaded)
                                handleFileUpload(e);
                                // setChangeComp(e.target.value);
                              }}
                            />
                            <p className="pro_pic pt-1">
                              {/* Add or drag <br /> a picture */}
                              {t("Add or drag a picture").slice(0, 7)}
                              <br />
                              {t("Add or drag a picture").slice(7)}
                            </p>
                          </div>

                          <div
                            className="assign_probablity_line"
                            style={{
                              width: "clamp(241px, 17.813vw, 17.813vw)",
                              height: "8px",
                              borderRadius: "0px 0px 5px 5px",
                              position: "relative",
                              bottom: "6px",
                              backgroundColor: getPriorityColor(
                                item.priorityid,
                              ),
                            }}
                          ></div>

                          <div>
                            <OverlayTrigger
                              key={index}
                              placement="top"
                              id="asctooltip"
                              // show={show}
                              // target={target}
                              delay={{ show: 400, hide: 500 }}
                              overlay={
                                <div
                                  id={`tooltip-${item.projectid}`}
                                  style={{ paddingLeft: "15rem" }}
                                >
                                  <p
                                    className="ascOverlay px-1 pointer"
                                    onClick={() => {
                                      window.localStorage.setItem(
                                        "projectid",
                                        item.projectid,
                                      );
                                      history.push(
                                        `/project/${item.projectid}`,
                                      );
                                    }}
                                  >
                                    {item.projectname.length > 30 &&
                                      item.projectname}
                                  </p>
                                </div>
                              }
                            >
                              <p
                                className="clntname pt-2 pointer"
                                onClick={() => {
                                  window.localStorage.setItem(
                                    "projectid",
                                    item.projectid,
                                  );
                                  history.push(`/project/${item.projectid}`);
                                }}
                              >
                                {item.projectname.length > 30
                                  ? item.projectname.slice(0, 30) + "..."
                                  : item.projectname}
                                <img
                                  alt=""
                                  src={ArrowIcon}
                                  className="ArrowIcon-show-in-mobile"
                                />
                              </p>
                            </OverlayTrigger>

                            <p
                              className="clntname pointer hide-on-mobile d-flex"
                              onClick={() => {
                                window.localStorage.setItem(
                                  "projectid",
                                  item.projectid,
                                );
                                history.push(`/project/${item.projectid}`);
                              }}
                            >
                              {item.clientname
                                ? item.clientname
                                : item.contactname
                                  ? item.contactname
                                  : ""}

                              {roleid ===
                                "08da3f0d-0371-4dd3-8c86-e51222d56188" && (
                                <span className="ms-auto">
                                  <img
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      dispatch(
                                        DeleteProject({
                                          projectid: item.projectid,
                                        }),
                                      );
                                    }}
                                    src={deleteIcon}
                                    className="card-plus-img ms-auto me-"
                                    style={{ width: "14px" }}
                                    alt=""
                                  />
                                </span>
                              )}
                            </p>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProjectBBList;
